import { supabase } from '../../../services/supabase';
import { TRawUserLevelCheckIns } from '../types/checkInQuality';

export const getUserLevelCheckIns = async (
  startDate: string,
  endDate: string,
  teamId?: string,
): Promise<TRawUserLevelCheckIns[]> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data, error } = await supabase.rpc('get_user_level_checkins', {
    end_date: endDate,
    start_date: startDate,
    team_id: teamId,
  });
  if (error) {
    throw new Error('Error fetching data');
  }
  return (data || []) as TRawUserLevelCheckIns[];
};
